import { Gauge } from "lucide-react";

const TIER_STYLES = {
  low: { color: "text-emerald-400", bg: "bg-emerald-500/10", border: "border-emerald-500/30", label: "LOW RISK" },
  medium: { color: "text-amber-500", bg: "bg-amber-500/10", border: "border-amber-500/30", label: "MED RISK" },
  high: { color: "text-orange-400", bg: "bg-orange-500/10", border: "border-orange-500/30", label: "HIGH RISK" },
  critical: { color: "text-red-400", bg: "bg-red-500/10", border: "border-red-500/40", label: "CRITICAL" },
};

export default function RiskScoreBadge({ risk, compact = false }) {
  if (!risk || risk.overall_score == null) return null;
  const cfg = TIER_STYLES[risk.tier] || TIER_STYLES.medium;
  return (
    <div
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded border ${cfg.bg} ${cfg.border}`}
      data-testid="risk-badge"
    >
      <Gauge className={`w-3 h-3 ${cfg.color}`} />
      <span className={`font-mono-data text-[9px] tracking-widest font-semibold ${cfg.color}`}>
        {compact ? `${risk.overall_score}` : `${cfg.label} · ${risk.overall_score}`}
      </span>
    </div>
  );
}
